
import { query, params, types, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _emergencyRoleInitQuery = (id: string) => ({
  organisations_by_pk: params(
    {
      id: rawString(id),
    },
    {
      name: types.string,
      emergencies: [{
        id: types.string,
        name: types.string,
      }],
    },
  )
});

type X = Unpacked<typeof _emergencyRoleInitQuery>;
export type Organisation = X['organisations_by_pk'];

export const emergencyRoleInitQuery = (id: string) => gql`${query(_emergencyRoleInitQuery(id))}`;
